/**
 * 日期数量分布组件（柱状图）
 * zxw
 * 创建时间：2025-12-10
 */

import { useEffect } from 'react';
import { Chart } from '@antv/g2';
import { Skeleton } from 'antd';
import CNF from '../../incs/Config.js';
import { isMobileDevice, NumberFormat } from '../../incs/FunHelper.js';

const ChartIntervalTypeCount = props => {
    const { children, id, title, subtitle, streamStatus } = props;

    const timestamp = new Date().getTime().toString();
    const chartId = `${id ? id : 'antv-g2-id'}.${timestamp}`;

    // 加载中显示默认图片
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }

    useEffect(() => {
        const chart = new Chart({
            container: chartId,
            autoFit: isMobileDevice,
        });

        chart.title({
            title: title,
            subtitle: subtitle,
        });

        // 格式化数据
        chart.data(JSON.parse(children));

        chart
            .interval()
            .encode('x', 'type')
            .encode('y', 'count')
            .encode('color', 'type')
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '类型', })
            .axis('y', {
                title: '数量',
                labelFormatter: (d) => NumberFormat(d),
            })
            // .animate('enter', {
            //     type: 'scaleInY',
            //     duration: CNF.animateDuration,
            // },)
            .tooltip({
                items: [(d => ({
                    name: '数量',
                    value: NumberFormat(d.count),
                }))]
            })
            .style('minWidth', 20)
            .style('maxWidth', 40);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, []);

    return <div id={chartId}></div>

}

export default ChartIntervalTypeCount;